export default __webpack_public_path__ + "static/media/photo-taking.9c2755d8.png";